"use client"

import {
  ProductPageAccordion,
  ProdutMeasurementRow,
} from '@/components/molecules';
import { SingleProductMeasurement } from '@/types/product';
import { useTranslate } from '@tolgee/react';

export const ProductDetailsMeasurements = ({
  measurements,
}: {
  measurements: SingleProductMeasurement[];
}) => {
  const { t } = useTranslate();
  return (
    <ProductPageAccordion
      heading={t("product_details.measurements_heading")}
      defaultOpen={false}
    >
      {measurements.map((item) => (
        <ProdutMeasurementRow
          key={item.label}
          measurement={item}
        />
      ))}
    </ProductPageAccordion>
  );
};
